// removed by extract-text-webpack-plugin
module.exports = {"modal":"_1tmjL","modal-background":"_2t2Ag","image":"_38lgZ","message":"_1vlgm","button":"_1yvS1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DonatePopup/DonatePopup.scss
// module id = ./src/components/DonatePopup/DonatePopup.scss
// module chunks = 5